import React from 'react';

import TablePage from '../../Components/TablePage/TablePage';

function TablePagesComponent(props) {
  return (
    <div className="table">
      <TablePage />
    </div>
  );
}

export default TablePagesComponent;
